@import '~@uppy/core/dist/style.min.css';
@import '~@uppy/dashboard/dist/style.min.css';
@import '~@uppy/image-editor/dist/style.min.css';
@import '~@uppy/webcam/dist/style.min.css';

.container {
  aspect-ratio: 4 / 3;
  max-width: var(--max-width);
  max-height: var(--max-height);
  height: var(--height);
  width: var(--width);
  box-sizing: border-box;
  padding: 0;
  .uppy-Root,
  .uppy-Dashboard {
    height: 100%;
  }
}
